(() => {
  const stylesheetUrl = document.currentScript?.dataset.cookieBannerStylesheet;
  if (!stylesheetUrl || !window.customElements) return;

  customElements.whenDefined('csm-cookie-consent').then(() => {
    const applyStyles = () => {
      let attached = false;
      document.querySelectorAll('csm-cookie-consent').forEach((host) => {
        const root = host.shadowRoot;
        if (!root) return;
        attached = true;
        if (root.querySelector('[data-decanter-cookie-banner]')) return;
        const stylesheet = document.createElement('link');
        stylesheet.rel = 'stylesheet';
        stylesheet.href = stylesheetUrl;
        stylesheet.dataset.decanterCookieBanner = '';
        root.appendChild(stylesheet);
      });
      return attached;
    };

    if (applyStyles()) return;
    const observer = new MutationObserver(() => {
      if (applyStyles()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
